import { ICommand } from 'core-ts-types';
import { AppointmentSchedulingServant, STCSchedulingConfigModel } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { AppointmentsTabsConfiguration } from './servants/appointments_tabs_configuration';
import MyAppointmentsStateService from './services/my_appointment_state_service';
import { IAppointmentCampaignConstant } from './types/appointment_interfaces';

angular.module('capability-ng-appointments').config(
  // tslint:disable-next-line:no-big-function
  ($stateProvider: ng.ui.IStateProvider, ngAppointmentsTabsConfigurationProvider: AppointmentsTabsConfiguration) => {
    'use strict';

    const appointmentSchedulingV3Redirect = {
      redirectToV3: (
        $state: ng.ui.IStateService,
        ngAppointmentSchedulingServant: AppointmentSchedulingServant,
        ngStcSchedulingConfigModel: STCSchedulingConfigModel
      ) => {
        return ngAppointmentSchedulingServant.getSchedulingConfig().then(() => {
          if (ngStcSchedulingConfigModel.read().v3_student_scheduler_flag) {
            $state.go('my.appointment-dashboard', { tab_name: 'appointments' });
          }
        });
      }
    };

    ngAppointmentsTabsConfigurationProvider.configure();
    $stateProvider
      .state('my.myAppointments', {
        url: 'my_appointments/',
        templateUrl: 'capability-ng-appointments/src/views/my_appointments/my_appointments.html',
        data: {
          viewTitle: 'My Appointments',
          hasMainMenu: true,
          ignoredInHistory: true
        },
        resolve: {
          ...appointmentSchedulingV3Redirect
        }
      })
      .state('my.myAppointments.detail', {
        url: 'details/:id',
        views: {
          '@my': {
            templateUrl: 'capability-ng-appointments/src/views/my_appointments/appointment_details.html'
          }
        },
        data: {
          ignoredInHistory: false,
          viewTitle: 'Appointment Detail'
        }
      })
      .state('my.myAppointments.request', {
        url: 'request/:id',
        views: {
          '@my': {
            templateUrl: 'capability-ng-appointments/src/views/my_appointments/appointment_request.html'
          }
        },
        data: {
          ignoredInHistory: false,
          viewTitle: 'Appointment Request'
        }
      })
      .state('my.myAppointments.upcoming', {
        url: 'upcoming/',
        data: {
          hasMainMenu: true,
          ignoredInHistory: false,
          viewTitle: 'Upcoming Appointments'
        },
        views: {
          'tab-content@my.myAppointments': {
            templateUrl: 'capability-ng-appointments/src/views/my_appointments/upcoming_appointments.html',
            controller: 'ngMyAppointmentsChildrenController',
            controllerAs: '$ctrl'
          }
        }
      })
      .state('my.myAppointments.past', {
        url: 'past/',
        data: {
          hasMainMenu: true,
          ignoredInHistory: false,
          viewTitle: 'Past Appointments'
        },
        views: {
          'tab-content@my.myAppointments': {
            templateUrl: 'capability-ng-appointments/src/views/my_appointments/past_appointments.html',
            controller: 'ngMyAppointmentsChildrenController',
            controllerAs: '$ctrl'
          }
        }
      })
      .state('my.myAppointments.active', {
        url: 'active/',
        data: {
          hasMainMenu: true,
          ignoredInHistory: false,
          viewTitle: 'Active Appointments'
        },
        views: {
          'tab-content@my.myAppointments': {
            templateUrl: 'capability-ng-appointments/src/views/my_appointments/active_appointments.html',
            controller: 'ngMyAppointmentsChildrenController',
            controllerAs: '$ctrl'
          }
        }
      })
      .state('my.appointments', {
        url: 'appointments/',
        data: {
          ignoredInHistory: true,
          viewTitle: 'My Appointments'
        },
        templateUrl: 'capability-ng-appointments/src/views/appointments/appointments.html',
        controller: 'ngAppointmentsController',
        controllerAs: '$ctrl',
        resolve: {
          redirectToV3: (
            $state: ng.ui.IStateService,
            ngAppointmentSchedulingServant: AppointmentSchedulingServant,
            ngStcSchedulingConfigModel: STCSchedulingConfigModel
          ) => {
            return ngAppointmentSchedulingServant.getSchedulingConfig().then(() => {
              if (ngStcSchedulingConfigModel.read().v3_student_scheduler_flag) {
                $state.go('my.appointment-new', { tabname: 'appointments' });
              }
            });
          }
        },
        onEnter: (
          $timeout: ng.ITimeoutService,
          appointmentCampaignConstant: IAppointmentCampaignConstant,
          ngMyAppointmentsStateService: MyAppointmentsStateService
        ) => {
          ngMyAppointmentsStateService.init();

          if (!appointmentCampaignConstant.isAppointmentCampaign) {
            $timeout(() => {
              ngMyAppointmentsStateService.go(ngMyAppointmentsStateService.states.reason);
            });
          } else {
            $timeout(() => {
              ngMyAppointmentsStateService.go(ngMyAppointmentsStateService.states.availableTimes, {
                invitationId: appointmentCampaignConstant.campaignInvitationId
              });
            });
          }
        },
        onExit: (ngMyAppointmentsStateService: MyAppointmentsStateService) => {
          ngMyAppointmentsStateService.refresh();
        }
      })
      .state('my.appointments.appointment_reason', {
        url: 'appointment_reason/',
        templateUrl: 'capability-ng-appointments/src/views/appointment_reason/appointment_reason.html',
        controller: 'ngAppointmentReasonController',
        controllerAs: '$ctrl',
        data: {
          viewTitle: 'Schedule Appointment | Select Reason'
        }
      })
      .state('my.appointments.location_staff', {
        url: 'location_staff/',
        templateUrl: 'capability-ng-appointments/src/views/location_staff/appointments_location_staff.html',
        controller: 'ngAppointmentsLocationStaffController',
        controllerAs: '$ctrl',
        data: {
          viewTitle: 'Schedule Appointment | Select location & Staff'
        }
      })
      .state('my.appointments.available_times', {
        url: 'available_times/',
        templateUrl: 'capability-ng-appointments/src/views/available_times/available_times.html',
        controller: 'ngAvailableTimesController',
        controllerAs: '$ctrl',
        params: {
          invitationId: 0,
          returnState: {}
        },
        data: {
          viewTitle: 'Schedule Appointment | Select Available Times'
        }
      })
      .state('my.appointments.walkin_times', {
        url: 'walkin_times/',
        templateUrl: 'capability-ng-appointments/src/views/walkin_times/walkin_times.html',
        controller: 'ngAvailableWalkinTimesController',
        controllerAs: '$ctrl',
        resolve: {
          _checkState: (ngMyAppointmentsStateService: MyAppointmentsStateService): ng.IHttpPromise<ICommand> | void => {
            ngMyAppointmentsStateService.checkState();
          }
        },
        data: {
          viewTitle: 'Schedule Appointment | View Drop-In Times'
        }
      })
      .state('my.appointments.alternate_appointment_times', {
        url: 'alternate_appointment_times/',
        templateUrl:
          'capability-ng-appointments/src/views/alternate_appointment_times/alternate_appointment_times.html',
        controller: 'AlternateAppointmentTimesController',
        params: {
          isNewRequest: true
        },
        controllerAs: '$ctrl',
        resolve: {
          _checkState: (ngMyAppointmentsStateService: MyAppointmentsStateService): ng.IHttpPromise<ICommand> | void => {
            ngMyAppointmentsStateService.checkState();
          }
        },
        data: {
          viewTitle: 'Schedule Appointment | View Alternate Appointment Times'
        }
      })
      .state('my.appointments.alternate_appointment_times_confirm', {
        url: 'alternate_appointment_times_confirm/',
        templateUrl:
          'capability-ng-appointments/src/views/alternate_appointment_times_confirm/alternate_appointment_times_confirm.html',
        controller: 'AlternateAppointmentTimesConfirmController',
        controllerAs: '$ctrl',
        resolve: {
          _checkState: (ngMyAppointmentsStateService: MyAppointmentsStateService): ng.IHttpPromise<ICommand> | void => {
            ngMyAppointmentsStateService.checkState();
          }
        },
        data: {
          viewTitle: 'Confirm Appointment Time'
        }
      })
      .state('my.appointments.confirm', {
        url: 'confirm/',
        templateUrl: 'capability-ng-appointments/src/views/confirm/confirm.html',
        controller: 'ngAppointmentsConfirmController',
        controllerAs: '$ctrl',
        resolve: {
          navigateContactInfo: (
            ngMyAppointmentsStateService: MyAppointmentsStateService,
            loadContactInfoCommand: ICommand
          ): ng.IHttpPromise<ICommand> | void => {
            if (ngMyAppointmentsStateService.checkState()) {
              return loadContactInfoCommand();
            }
          }
        },
        data: {
          viewTitle: 'Confirm Appointment Schedule'
        }
      })
      .state('my.appointments.scheduled', {
        url: 'scheduled/',
        templateUrl: 'capability-ng-appointments/src/views/scheduled/scheduled.html',
        controller: 'ngAppointmentsScheduledController',
        controllerAs: '$ctrl',
        data: {
          viewTitle: 'Appointment Confirmation'
        }
      });
  }
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/routes.ts